export const locale = {
    lang: 'en',
    tree_ngx: {
        NO_MATCH_SEARCH: 'There are no matches in the search'
    }
};
